export default "__VITE_ASSET__ef5881e7__"